import DOMPurify from 'isomorphic-dompurify';
import { HTMLAttributes, useMemo } from 'react';
interface Props extends Omit<HTMLAttributes<HTMLDivElement>, 'dangerouslySetInnerHTML'> {
  content: string;
  as?: 'div' | 'p' | 'span' | 'section';
}
function SafeHtml({
  content,
  as: Component = 'div',
  className,
  ...props
}: Props) {
  const sanitizedContent = useMemo(() => DOMPurify.sanitize(content), [content]);
  const elementProps = {
    ...props,
    className,
    dangerouslySetInnerHTML: {
      __html: sanitizedContent
    }
  };
  return <Component {...elementProps} data-sentry-element="Component" data-sentry-component="SafeHtml" data-sentry-source-file="safe-html.tsx" />;
}
export default SafeHtml;